// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 提现申请列表 GET /withdraw/manage/list */
export async function withdrawList(
  params: {
    current?: number;
    pageSize?: number;
    status?: number;
    username?: string;
  },
  options?: { [key: string]: any }
) {
  return request<API.RPageWithdrawRecord>("/withdraw/manage/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 提现审核 POST /withdraw/manage/audit */
export async function withdrawAudit(
  body: { id?: number; status?: number; remark?: string },
  options?: { [key: string]: any }
) {
  return request<API.RString>("/withdraw/manage/audit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
